import HTTP from "../common/ajax";

class ContactModel {
  async create(payload) {
    try {
      const res = await HTTP.post("public/contact/new", payload);
      return Promise.resolve(res.data);
    } catch (error) {
      return Promise.reject(error.response.data);
    }
  }
}

export default new ContactModel();
